import { render, staticRenderFns } from "./DesignStudioBuildV3.vue?vue&type=template&id=456bc090"
import script from "./DesignStudioBuildV3.vue?vue&type=script&lang=js"
export * from "./DesignStudioBuildV3.vue?vue&type=script&lang=js"
import style0 from "./DesignStudioBuildV3.vue?vue&type=style&index=0&id=456bc090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports